module.exports = __webpack_public_path__ + "img/custom-colors@2x.611af253.png";